module.exports = __webpack_public_path__ + "img/d-3.8938692d.png";